import styled from "styled-components";
import { Animations, Colors } from "../../../../constants/Colors";

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
`;

export const Title = styled.h1`
    color: ${Colors.secondary[100]};
    font-size: 5rem;
    font-weight: bold;
    margin: 0;
`;

export const Footer = styled.p`
    position: absolute;
    bottom: 0;

    font-size: 1.75rem;
    color: ${Colors.commons.grayFading};

    animation: ${Animations.blink} 5s infinite;
`;


